import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, OnInit, ElementRef, ViewChildren, AfterViewInit } from '@angular/core';
import { FormControlName, FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { GenericValidator } from '../../shared/generic-validator';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { Observable, fromEvent } from 'rxjs';
import { merge } from 'rxjs/operators';
import { ResetPassword } from './reset-password';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'wsg-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  errorMessage: string;
  resetPasswordForm: FormGroup;
  processing = false;

  constructor(private _formBuilder: FormBuilder, private router: Router, private loginService: LoginService,
              private snackbar: MatSnackBar, private route: ActivatedRoute, private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.resetPasswordForm = this._formBuilder.group({
      password: [''],
      confirmPassword: ['']
    }, { validator: this.passwordCompare });
  }

  passwordCompare(c: AbstractControl): {[key: string]: boolean} | null {
    const password = c.get('password');
    const confirmPassword = c.get('confirmPassword');

    if (password.pristine || confirmPassword.pristine) {
      return null;
    }

    if (password.value !== confirmPassword.value){
      confirmPassword.setErrors({match: true});
    } else {
      confirmPassword.setErrors(null);
    }

    return null;
  }

  getSafeHtml(input: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(input);
  }

  reset(): void {

    const model = new ResetPassword(this.resetPasswordForm.get('password').value,
                                    this.route.snapshot.queryParams['email'],
                                    this.route.snapshot.queryParams['token'],
                                    this.resetPasswordForm.get('confirmPassword').value);

    this.processing = true;

    this.loginService.resetPassword(model)
                      .subscribe(result => {
                        this.snackbar.open('Password Reset', 'DISMISS', {
                          duration: 2000
                        });

                        this.processing = false;

                        this.router.navigate(['/login']);

                      }, error => {
                        this.errorMessage = '';

                        error.error.forEach(element => {
                          this.errorMessage += element.description + '<br/>';
                        });

                        this.processing = false;
                      });
  }
}
